import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, HostBinding, NgModule, inject, Optional, ChangeDetectorRef, ViewChild } from '@angular/core';
import * as i2 from '@angular/forms';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@spartacus/core';
import { GlobalMessageType, useFeatureStyles, UrlModule, I18nModule, FeaturesConfigModule, provideDefaultConfig, NotAuthGuard, AuthService, GlobalMessageService, WindowRef, RoutingService, AuthGuard } from '@spartacus/core';
import * as i4 from '@spartacus/storefront';
import { CustomFormValidators, FormErrorsModule, SpinnerModule, PasswordVisibilityToggleModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent, PageSlotModule, BtnLikeLinkModule, DomChangeModule, LAUNCH_CALLER, DIALOG_TYPE, LaunchDialogService, KeyboardFocusModule, IconModule } from '@spartacus/storefront';
import { BehaviorSubject, from, of, tap as tap$1 } from 'rxjs';
import { tap, withLatestFrom, switchMap } from 'rxjs/operators';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$2 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i2$1 from '@spartacus/user/account/root';
import { VerificationTokenFacade, VERIFICATION_TOKEN_DIALOG_ACTION } from '@spartacus/user/account/root';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const _c0 = a0 => ({
  label: a0
});
const _c1 = () => ({
  cxRoute: "forgotPassword"
});
function LoginFormComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 9);
  }
}
const _c2 = () => ({
  cxRoute: "login"
});
function LoginComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "cx-page-slot", 4);
    i0.ɵɵlistener("cxDomChange", function LoginComponent_ng_container_0_ng_container_1_Template_cx_page_slot_cxDomChange_4_listener($event) {
      const greeting_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onRootNavBtnAdded($event, greeting_r2));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, ctx_r2.greeting$), " ");
  }
}
function LoginComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LoginComponent_ng_container_0_ng_container_1_Template, 5, 3, "ng-container", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r2.greeting$));
  }
}
function LoginComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵpipe(1, "cxUrl");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 2, i0.ɵɵpureFunction0(6, _c2)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "miniLogin.signInRegister"));
  }
}
const _c3 = () => ({
  cxRoute: "logout"
});
function MyAccountV2UserComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "a", 3);
    i0.ɵɵpipe(4, "cxUrl");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const user_r1 = ctx.ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", user_r1.title, "", user_r1.name, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(4, 4, i0.ɵɵpureFunction0(8, _c3)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(6, 6, "myAccountV2User.signOut"), " ");
  }
}
function OneTimePasswordLoginFormComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 9);
  }
}
function VerificationTokenDialogComponent_h3_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "verificationTokenDialog.title"), " ");
  }
}
function VerificationTokenDialogComponent_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "verificationTokenDialog.title"), " ");
  }
}
const _c4 = ["noReceiveCodeLink"];
const _c5 = ["resendLink"];
const _c6 = a0 => ({
  seconds: a0
});
const _c7 = a0 => ({
  "disabled-link": a0
});
const _c8 = a0 => ({
  waitTime: a0
});
function VerificationTokenFormComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 14);
  }
}
function VerificationTokenFormComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "register.rateLimitForRegistrationMessage", i0.ɵɵpureFunction1(4, _c6, ctx_r0.waitTimeForRateLimit)), " ");
  }
}
function VerificationTokenFormComponent_div_17_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "verificationTokenForm.sendRateLime", i0.ɵɵpureFunction1(4, _c8, ctx_r0.waitTime)), " ");
  }
}
function VerificationTokenFormComponent_div_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17)(2, "span", 18)(3, "a", 19, 0);
    i0.ɵɵlistener("keydown.enter", function VerificationTokenFormComponent_div_17_Template_a_keydown_enter_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.resendOTP());
    })("keydown.space", function VerificationTokenFormComponent_div_17_Template_a_keydown_space_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.resendOTP());
    })("click", function VerificationTokenFormComponent_div_17_Template_a_click_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.resendOTP());
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, VerificationTokenFormComponent_div_17_ng_container_7_Template, 3, 6, "ng-container", 20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 21)(9, "a", 22, 1);
    i0.ɵɵlistener("keydown", function VerificationTokenFormComponent_div_17_Template_a_keydown_9_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onOpenInfoDailogKeyDown($event));
    })("click", function VerificationTokenFormComponent_div_17_Template_a_click_9_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.openInfoDailog());
    });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c7, ctx_r0.isResendDisabled));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "verificationTokenForm.resend"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isResendDisabled);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 6, "verificationTokenForm.noReceiveCode"), " ");
  }
}
class LoginFormComponentService {
  constructor(auth, globalMessage, winRef) {
    this.auth = auth;
    this.globalMessage = globalMessage;
    this.winRef = winRef;
    this.busy$ = new BehaviorSubject(false);
    this.isUpdating$ = this.busy$.pipe(tap(state => {
      const userId = this.winRef.nativeWindow?.history?.state?.['newUid'];
      if (userId) {
        this.form.patchValue({
          userId
        });
      }
      state === true ? this.form.disable() : this.form.enable();
    }));
    this.form = new UntypedFormGroup({
      userId: new UntypedFormControl('', [Validators.required, CustomFormValidators.emailValidator]),
      password: new UntypedFormControl('', Validators.required)
    });
  }
  login() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this.busy$.next(true);
    from(this.auth.loginWithCredentials(
    // TODO: consider dropping toLowerCase as this should not be part of the UI,
    // as it's too opinionated and doesn't work with other AUTH services
    this.form.value.userId.toLowerCase(), this.form.value.password)).pipe(withLatestFrom(this.auth.isUserLoggedIn()), tap(([_, isLoggedIn]) => this.onSuccess(isLoggedIn))).subscribe();
  }
  onSuccess(isLoggedIn) {
    if (isLoggedIn) {
      // We want to remove error messages on successful login (primary the bad
      // username/password combination)
      this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
      this.form.reset();
    }
    this.busy$.next(false);
  }
  static {
    this.ɵfac = function LoginFormComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoginFormComponentService)(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i1.GlobalMessageService), i0.ɵɵinject(i1.WindowRef));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LoginFormComponentService,
      factory: LoginFormComponentService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginFormComponentService, [{
    type: Injectable
  }], () => [{
    type: i1.AuthService
  }, {
    type: i1.GlobalMessageService
  }, {
    type: i1.WindowRef
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LoginFormComponent {
  constructor(service) {
    this.service = service;
    this.form = this.service.form;
    this.isUpdating$ = this.service.isUpdating$;
    this.style = true;
    useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
  }
  onSubmit() {
    this.service.login();
  }
  static {
    this.ɵfac = function LoginFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoginFormComponent)(i0.ɵɵdirectiveInject(LoginFormComponentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LoginFormComponent,
      selectors: [["cx-login-form"]],
      hostVars: 2,
      hostBindings: function LoginFormComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("user-form", ctx.style);
        }
      },
      standalone: false,
      decls: 31,
      vars: 49,
      consts: [["class", "overlay", 4, "ngIf"], [3, "ngSubmit", "formGroup"], [1, "label-content"], ["required", "true", "type", "email", "formControlName", "userId", 1, "form-control", 3, "placeholder"], ["id", "userIdError", 3, "translationParams", "control"], ["required", "true", "type", "password", "formControlName", "password", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordError", 3, "translationParams", "control"], [1, "btn-link", 3, "routerLink"], ["type", "submit", 1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "overlay"]],
      template: function LoginFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, LoginFormComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 0);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵelementStart(2, "form", 1);
          i0.ɵɵlistener("ngSubmit", function LoginFormComponent_Template_form_ngSubmit_2_listener() {
            return ctx.onSubmit();
          });
          i0.ɵɵelement(3, "cx-form-required-legend");
          i0.ɵɵelementStart(4, "label")(5, "span", 2);
          i0.ɵɵtext(6);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵelement(8, "cx-form-required-asterisks");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(9, "input", 3);
          i0.ɵɵpipe(10, "cxTranslate");
          i0.ɵɵpipe(11, "cxTranslate");
          i0.ɵɵelement(12, "cx-form-errors", 4);
          i0.ɵɵpipe(13, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(14, "label")(15, "span", 2);
          i0.ɵɵtext(16);
          i0.ɵɵpipe(17, "cxTranslate");
          i0.ɵɵelement(18, "cx-form-required-asterisks");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(19, "input", 5);
          i0.ɵɵpipe(20, "cxTranslate");
          i0.ɵɵpipe(21, "cxTranslate");
          i0.ɵɵelement(22, "cx-form-errors", 6);
          i0.ɵɵpipe(23, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(24, "a", 7);
          i0.ɵɵpipe(25, "cxUrl");
          i0.ɵɵtext(26);
          i0.ɵɵpipe(27, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(28, "button", 8);
          i0.ɵɵtext(29);
          i0.ɵɵpipe(30, "cxTranslate");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          let tmp_5_0;
          let tmp_12_0;
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 20, ctx.isUpdating$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 22, "loginForm.emailAddress.label"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 24, "loginForm.emailAddress.placeholder"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(11, 26, "loginForm.emailAddress.label"))("aria-invalid", ((tmp_5_0 = ctx.form.get("userId")) == null ? null : tmp_5_0.touched) && ((tmp_5_0 = ctx.form.get("userId")) == null ? null : tmp_5_0.invalid))("aria-errormessage", "userIdError");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(44, _c0, i0.ɵɵpipeBind1(13, 28, "loginForm.emailAddress.label")))("control", ctx.form.get("userId"));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 30, "loginForm.password.label"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(20, 32, "loginForm.password.placeholder"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(21, 34, "loginForm.password.placeholder"))("aria-invalid", ((tmp_12_0 = ctx.form.get("password")) == null ? null : tmp_12_0.touched) && ((tmp_12_0 = ctx.form.get("password")) == null ? null : tmp_12_0.invalid))("aria-errormessage", "passwordError");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(46, _c0, i0.ɵɵpipeBind1(23, 36, "loginForm.password.label")))("control", ctx.form.get("password"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(25, 38, i0.ɵɵpureFunction0(48, _c1)));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(27, 40, "loginForm.forgotPassword"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("disabled", ctx.form.disabled);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(30, 42, "loginForm.signIn"), " ");
        }
      },
      dependencies: [i1$1.NgIf, i2.ɵNgNoValidate, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.RequiredValidator, i2.FormGroupDirective, i2.FormControlName, i1$2.RouterLink, i4.FormErrorsComponent, i4.SpinnerComponent, i4.PasswordVisibilityToggleDirective, i4.FormRequiredAsterisksComponent, i4.FormRequiredLegendComponent, i1$1.AsyncPipe, i1.UrlPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginFormComponent, [{
    type: Component,
    args: [{
      selector: 'cx-login-form',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-spinner class=\"overlay\" *ngIf=\"isUpdating$ | async\"></cx-spinner>\n\n<form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\">\n  <!-- TODO: (CXSPA-5953) Remove feature flags next major -->\n  <cx-form-required-legend />\n  <label>\n    <span class=\"label-content\">\n      {{ 'loginForm.emailAddress.label' | cxTranslate }}\n      <cx-form-required-asterisks />\n    </span>\n    <input\n      required=\"true\"\n      type=\"email\"\n      class=\"form-control\"\n      placeholder=\"{{ 'loginForm.emailAddress.placeholder' | cxTranslate }}\"\n      [attr.aria-label]=\"'loginForm.emailAddress.label' | cxTranslate\"\n      formControlName=\"userId\"\n      [attr.aria-invalid]=\"\n        form.get('userId')?.touched && form.get('userId')?.invalid\n      \"\n      [attr.aria-errormessage]=\"'userIdError'\"\n    />\n\n    <cx-form-errors\n      id=\"userIdError\"\n      [translationParams]=\"{\n        label: 'loginForm.emailAddress.label' | cxTranslate,\n      }\"\n      [control]=\"form.get('userId')\"\n    ></cx-form-errors>\n  </label>\n\n  <label>\n    <span class=\"label-content\">\n      {{ 'loginForm.password.label' | cxTranslate }}\n      <cx-form-required-asterisks />\n    </span>\n    <input\n      required=\"true\"\n      type=\"password\"\n      class=\"form-control\"\n      placeholder=\"{{ 'loginForm.password.placeholder' | cxTranslate }}\"\n      formControlName=\"password\"\n      [attr.aria-label]=\"'loginForm.password.placeholder' | cxTranslate\"\n      [attr.aria-invalid]=\"\n        form.get('password')?.touched && form.get('password')?.invalid\n      \"\n      [attr.aria-errormessage]=\"'passwordError'\"\n      cxPasswordVisibilitySwitch\n    />\n\n    <cx-form-errors\n      id=\"passwordError\"\n      [translationParams]=\"{\n        label: 'loginForm.password.label' | cxTranslate,\n      }\"\n      [control]=\"form.get('password')\"\n    ></cx-form-errors>\n  </label>\n\n  <a [routerLink]=\"{ cxRoute: 'forgotPassword' } | cxUrl\" class=\"btn-link\">\n    {{ 'loginForm.forgotPassword' | cxTranslate }}\n  </a>\n\n  <button\n    type=\"submit\"\n    class=\"btn btn-block btn-primary\"\n    [disabled]=\"form.disabled\"\n  >\n    {{ 'loginForm.signIn' | cxTranslate }}\n  </button>\n</form>\n"
    }]
  }], () => [{
    type: LoginFormComponentService
  }], {
    style: [{
      type: HostBinding,
      args: ['class.user-form']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LoginFormModule {
  static {
    this.ɵfac = function LoginFormModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoginFormModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LoginFormModule,
      declarations: [LoginFormComponent],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, FormErrorsModule, SpinnerModule, PasswordVisibilityToggleModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ReturningCustomerLoginComponent: {
            component: LoginFormComponent,
            guards: [NotAuthGuard],
            providers: [{
              provide: LoginFormComponentService,
              useClass: LoginFormComponentService,
              deps: [AuthService, GlobalMessageService, WindowRef]
            }]
          }
        }
      })],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, FormErrorsModule, SpinnerModule, PasswordVisibilityToggleModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginFormModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, FormErrorsModule, SpinnerModule, PasswordVisibilityToggleModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ReturningCustomerLoginComponent: {
            component: LoginFormComponent,
            guards: [NotAuthGuard],
            providers: [{
              provide: LoginFormComponentService,
              useClass: LoginFormComponentService,
              deps: [AuthService, GlobalMessageService, WindowRef]
            }]
          }
        }
      })],
      declarations: [LoginFormComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LoginRegisterComponent {
  constructor(activatedRoute) {
    this.activatedRoute = activatedRoute;
    this.loginAsGuest = false;
    this.routingService = inject(RoutingService, {
      optional: true
    });
  }
  ngOnInit() {
    this.loginAsGuest = this.activatedRoute.snapshot.queryParams['forced'];
  }
  navigateTo(cxRoute) {
    this.routingService?.go({
      cxRoute
    });
  }
  static {
    this.ɵfac = function LoginRegisterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoginRegisterComponent)(i0.ɵɵdirectiveInject(i1$2.ActivatedRoute));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LoginRegisterComponent,
      selectors: [["cx-login-register"]],
      standalone: false,
      decls: 7,
      vars: 7,
      consts: [[1, "register"], [1, "cx-section-title"], [1, "btn", "btn-block", "btn-secondary", 3, "click", "ngClass"]],
      template: function LoginRegisterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "p", 1);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "button", 2);
          i0.ɵɵlistener("click", function LoginRegisterComponent_Template_button_click_4_listener() {
            return ctx.navigateTo(ctx.loginAsGuest ? "checkoutLogin" : "register");
          });
          i0.ɵɵtext(5);
          i0.ɵɵpipe(6, "cxTranslate");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "loginForm.dontHaveAccount"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngClass", ctx.loginAsGuest ? "btn-guest" : "btn-register");
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 5, ctx.loginAsGuest ? "loginForm.guestCheckout" : "loginForm.register"), " ");
        }
      },
      dependencies: [i1$1.NgClass, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginRegisterComponent, [{
    type: Component,
    args: [{
      selector: 'cx-login-register',
      standalone: false,
      template: "<div class=\"register\">\n  <p class=\"cx-section-title\">\n    {{ 'loginForm.dontHaveAccount' | cxTranslate }}\n  </p>\n\n  <button\n    (click)=\"navigateTo(loginAsGuest ? 'checkoutLogin' : 'register')\"\n    class=\"btn btn-block btn-secondary\"\n    [ngClass]=\"loginAsGuest ? 'btn-guest' : 'btn-register'\"\n  >\n    {{\n      (loginAsGuest ? 'loginForm.guestCheckout' : 'loginForm.register')\n        | cxTranslate\n    }}\n  </button>\n</div>\n"
    }]
  }], () => [{
    type: i1$2.ActivatedRoute
  }], {
    routingService: [{
      type: Optional
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LoginRegisterModule {
  static {
    this.ɵfac = function LoginRegisterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoginRegisterModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LoginRegisterModule,
      declarations: [LoginRegisterComponent],
      imports: [CommonModule, RouterModule, UrlModule, PageSlotModule, I18nModule, BtnLikeLinkModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ReturningCustomerRegisterComponent: {
            component: LoginRegisterComponent,
            guards: [NotAuthGuard]
          }
        }
      })],
      imports: [CommonModule, RouterModule, UrlModule, PageSlotModule, I18nModule, BtnLikeLinkModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginRegisterModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, UrlModule, PageSlotModule, I18nModule, BtnLikeLinkModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ReturningCustomerRegisterComponent: {
            component: LoginRegisterComponent,
            guards: [NotAuthGuard]
          }
        }
      })],
      declarations: [LoginRegisterComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LoginComponent {
  constructor(auth, userAccount, translation) {
    this.auth = auth;
    this.userAccount = userAccount;
    this.translation = translation;
  }
  ngOnInit() {
    this.user$ = this.auth.isUserLoggedIn().pipe(switchMap(isUserLoggedIn => {
      if (isUserLoggedIn) {
        return this.userAccount.get();
      } else {
        return of(undefined);
      }
    }));
    this.greeting$ = this.user$.pipe(switchMap(user => this.translation.translate(`miniLogin.userGreeting`, {
      name: user?.name
    })));
  }
  onRootNavBtnAdded($event, greeting) {
    $event.target.setAttribute('aria-label', greeting);
  }
  static {
    this.ɵfac = function LoginComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoginComponent)(i0.ɵɵdirectiveInject(i1.AuthService), i0.ɵɵdirectiveInject(i2$1.UserAccountFacade), i0.ɵɵdirectiveInject(i1.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LoginComponent,
      selectors: [["cx-login"]],
      standalone: false,
      decls: 4,
      vars: 4,
      consts: [["login", ""], [4, "ngIf", "ngIfElse"], [4, "ngIf"], [1, "cx-login-greet"], ["cxDomChangeTargetSelector", "nav ul li:first-child button", "id", "account-nav", "position", "HeaderLinks", 3, "cxDomChange"], ["role", "link", 3, "routerLink"]],
      template: function LoginComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, LoginComponent_ng_container_0_Template, 3, 3, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, LoginComponent_ng_template_2_Template, 4, 7, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const login_r4 = i0.ɵɵreference(3);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.user$))("ngIfElse", login_r4);
        }
      },
      dependencies: [i1$1.NgIf, i1$2.RouterLink, i4.PageSlotComponent, i4.DomChangeDirective, i1$1.AsyncPipe, i1.UrlPipe, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginComponent, [{
    type: Component,
    args: [{
      selector: 'cx-login',
      standalone: false,
      template: "<ng-container *ngIf=\"user$ | async as user; else login\">\n  <ng-container *ngIf=\"greeting$ | async as greeting\">\n    <div class=\"cx-login-greet\">\n      {{ greeting$ | async }}\n    </div>\n    <cx-page-slot\n      (cxDomChange)=\"onRootNavBtnAdded($event, greeting)\"\n      cxDomChangeTargetSelector=\"nav ul li:first-child button\"\n      id=\"account-nav\"\n      position=\"HeaderLinks\"\n    ></cx-page-slot>\n  </ng-container>\n</ng-container>\n\n<ng-template #login>\n  <a role=\"link\" [routerLink]=\"{ cxRoute: 'login' } | cxUrl\">{{\n    'miniLogin.signInRegister' | cxTranslate\n  }}</a>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1.AuthService
  }, {
    type: i2$1.UserAccountFacade
  }, {
    type: i1.TranslationService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LoginModule {
  static {
    this.ɵfac = function LoginModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoginModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LoginModule,
      declarations: [LoginComponent],
      imports: [CommonModule, RouterModule, UrlModule, PageSlotModule, I18nModule, DomChangeModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          LoginComponent: {
            component: LoginComponent
          }
        }
      })],
      imports: [CommonModule, RouterModule, UrlModule, PageSlotModule, I18nModule, DomChangeModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, UrlModule, PageSlotModule, I18nModule, DomChangeModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          LoginComponent: {
            component: LoginComponent
          }
        }
      })],
      declarations: [LoginComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2UserComponent extends LoginComponent {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵMyAccountV2UserComponent_BaseFactory;
      return function MyAccountV2UserComponent_Factory(__ngFactoryType__) {
        return (ɵMyAccountV2UserComponent_BaseFactory || (ɵMyAccountV2UserComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MyAccountV2UserComponent)))(__ngFactoryType__ || MyAccountV2UserComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2UserComponent,
      selectors: [["cx-my-account-v2-user"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 3,
      consts: [[1, "cx-my-account-v2-user"], [4, "ngIf"], [1, "cx-name"], [1, "cx-sign-out", 3, "routerLink"]],
      template: function MyAccountV2UserComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, MyAccountV2UserComponent_ng_container_1_Template, 7, 9, "ng-container", 1);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx.user$));
        }
      },
      dependencies: [i1$1.NgIf, i1$2.RouterLink, i1$1.AsyncPipe, i1.UrlPipe, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2UserComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-user',
      standalone: false,
      template: "<div class=\"cx-my-account-v2-user\">\n  <ng-container *ngIf=\"user$ | async as user\">\n    <div class=\"cx-name\">{{ user.title }}{{ user.name }}</div>\n    <a\n      class=\"cx-sign-out\"\n      [routerLink]=\"\n        {\n          cxRoute: 'logout',\n        } | cxUrl\n      \"\n      >{{ 'myAccountV2User.signOut' | cxTranslate }}\n    </a>\n  </ng-container>\n</div>\n"
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2UserModule {
  static {
    this.ɵfac = function MyAccountV2UserModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2UserModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MyAccountV2UserModule,
      declarations: [MyAccountV2UserComponent],
      imports: [CommonModule, RouterModule, UrlModule, I18nModule],
      exports: [MyAccountV2UserComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          MyAccountViewUserComponent: {
            component: MyAccountV2UserComponent,
            guards: [AuthGuard]
          }
        }
      })],
      imports: [CommonModule, RouterModule, UrlModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2UserModule, [{
    type: NgModule,
    args: [{
      providers: [provideDefaultConfig({
        cmsComponents: {
          MyAccountViewUserComponent: {
            component: MyAccountV2UserComponent,
            guards: [AuthGuard]
          }
        }
      })],
      declarations: [MyAccountV2UserComponent],
      exports: [MyAccountV2UserComponent],
      imports: [CommonModule, RouterModule, UrlModule, I18nModule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const ONE_TIME_PASSWORD_LOGIN_PURPOSE = 'LOGIN';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OneTimePasswordLoginFormComponent {
  constructor() {
    this.routingService = inject(RoutingService);
    this.verificationTokenFacade = inject(VerificationTokenFacade);
    this.winRef = inject(WindowRef);
    this.busy$ = new BehaviorSubject(false);
    this.isUpdating$ = this.busy$.pipe(tap$1(state => {
      const userId = this.winRef.nativeWindow?.history?.state?.['newUid'];
      if (userId) {
        this.form.patchValue({
          userId
        });
      }
      state === true ? this.form.disable() : this.form.enable();
    }));
    this.form = new UntypedFormGroup({
      userId: new UntypedFormControl('', [Validators.required, CustomFormValidators.emailValidator]),
      password: new UntypedFormControl('', Validators.required)
    });
    this.style = true;
    useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
  }
  onSubmit() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this.busy$.next(true);
    const verificationTokenCreation = this.collectDataFromLoginForm();
    this.verificationTokenFacade.createVerificationToken(verificationTokenCreation).subscribe({
      next: result => this.goToVerificationTokenForm(result, verificationTokenCreation),
      error: error => {
        this.routingService.go({
          cxRoute: 'verifyToken'
        }, {
          state: {
            loginId: verificationTokenCreation.loginId,
            password: verificationTokenCreation.password,
            errorStatus: error.status
          }
        });
        this.busy$.next(false);
      },
      complete: () => this.onCreateVerificationTokenComplete()
    });
  }
  goToVerificationTokenForm(verificationToken, verificationTokenCreation) {
    this.routingService.go({
      cxRoute: 'verifyToken'
    }, {
      state: {
        loginId: verificationTokenCreation.loginId,
        password: verificationTokenCreation.password,
        tokenId: verificationToken.tokenId,
        expiresIn: verificationToken.expiresIn
      }
    });
  }
  onCreateVerificationTokenComplete() {
    this.form.reset();
    this.busy$.next(false);
  }
  collectDataFromLoginForm() {
    return {
      // TODO: consider dropping toLowerCase as this should not be part of the UI,
      // as it's too opinionated and doesn't work with other AUTH services
      loginId: this.form.value.userId.toLowerCase(),
      password: this.form.value.password,
      purpose: ONE_TIME_PASSWORD_LOGIN_PURPOSE
    };
  }
  static {
    this.ɵfac = function OneTimePasswordLoginFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OneTimePasswordLoginFormComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OneTimePasswordLoginFormComponent,
      selectors: [["cx-otp-login-form"]],
      hostVars: 2,
      hostBindings: function OneTimePasswordLoginFormComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("user-form", ctx.style);
        }
      },
      standalone: false,
      decls: 28,
      vars: 36,
      consts: [["class", "overlay", 4, "ngIf"], [3, "ngSubmit", "formGroup"], [1, "label-content"], ["required", "true", "type", "email", "formControlName", "userId", 1, "form-control", 3, "placeholder"], ["id", "userIdError", 3, "control"], ["required", "true", "type", "password", "formControlName", "password", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordError", 3, "control"], [1, "btn-link", 3, "routerLink"], ["type", "submit", 1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "overlay"]],
      template: function OneTimePasswordLoginFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, OneTimePasswordLoginFormComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 0);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵelementStart(2, "form", 1);
          i0.ɵɵlistener("ngSubmit", function OneTimePasswordLoginFormComponent_Template_form_ngSubmit_2_listener() {
            return ctx.onSubmit();
          });
          i0.ɵɵelement(3, "cx-form-required-legend");
          i0.ɵɵelementStart(4, "label")(5, "span", 2);
          i0.ɵɵtext(6);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵelement(8, "cx-form-required-asterisks");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(9, "input", 3);
          i0.ɵɵpipe(10, "cxTranslate");
          i0.ɵɵelement(11, "cx-form-errors", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "label")(13, "span", 2);
          i0.ɵɵtext(14);
          i0.ɵɵpipe(15, "cxTranslate");
          i0.ɵɵelement(16, "cx-form-required-asterisks");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(17, "input", 5);
          i0.ɵɵpipe(18, "cxTranslate");
          i0.ɵɵpipe(19, "cxTranslate");
          i0.ɵɵelement(20, "cx-form-errors", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(21, "a", 7);
          i0.ɵɵpipe(22, "cxUrl");
          i0.ɵɵtext(23);
          i0.ɵɵpipe(24, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(25, "button", 8);
          i0.ɵɵtext(26);
          i0.ɵɵpipe(27, "cxTranslate");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          let tmp_4_0;
          let tmp_10_0;
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 17, ctx.isUpdating$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 19, "loginForm.emailAddress.label"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 21, "loginForm.emailAddress.placeholder"));
          i0.ɵɵattribute("aria-invalid", ((tmp_4_0 = ctx.form.get("userId")) == null ? null : tmp_4_0.touched) && ((tmp_4_0 = ctx.form.get("userId")) == null ? null : tmp_4_0.invalid))("aria-errormessage", "userIdError");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("control", ctx.form.get("userId"));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 23, "loginForm.password.label"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(18, 25, "loginForm.password.placeholder"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(19, 27, "loginForm.password.placeholder"))("aria-invalid", ((tmp_10_0 = ctx.form.get("password")) == null ? null : tmp_10_0.touched) && ((tmp_10_0 = ctx.form.get("password")) == null ? null : tmp_10_0.invalid))("aria-errormessage", "passwordError");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("control", ctx.form.get("password"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(22, 29, i0.ɵɵpureFunction0(35, _c1)));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 31, "loginForm.forgotPassword"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("disabled", ctx.form.disabled);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(27, 33, "loginForm.signIn"), " ");
        }
      },
      dependencies: [i1$1.NgIf, i2.ɵNgNoValidate, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.RequiredValidator, i2.FormGroupDirective, i2.FormControlName, i1$2.RouterLink, i4.FormErrorsComponent, i4.SpinnerComponent, i4.PasswordVisibilityToggleDirective, i4.FormRequiredAsterisksComponent, i4.FormRequiredLegendComponent, i1$1.AsyncPipe, i1.UrlPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OneTimePasswordLoginFormComponent, [{
    type: Component,
    args: [{
      selector: 'cx-otp-login-form',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-spinner class=\"overlay\" *ngIf=\"isUpdating$ | async\"></cx-spinner>\n\n<form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\">\n  <!-- TODO: (CXSPA-5953) Remove feature flags next major -->\n  <cx-form-required-legend />\n  <label>\n    <span class=\"label-content\">\n      {{ 'loginForm.emailAddress.label' | cxTranslate }}\n      <cx-form-required-asterisks />\n    </span>\n    <input\n      required=\"true\"\n      type=\"email\"\n      class=\"form-control\"\n      formControlName=\"userId\"\n      placeholder=\"{{ 'loginForm.emailAddress.placeholder' | cxTranslate }}\"\n      [attr.aria-invalid]=\"\n        form.get('userId')?.touched && form.get('userId')?.invalid\n      \"\n      [attr.aria-errormessage]=\"'userIdError'\"\n    />\n    <cx-form-errors\n      id=\"userIdError\"\n      [control]=\"form.get('userId')\"\n    ></cx-form-errors>\n  </label>\n\n  <label>\n    <span class=\"label-content\">\n      {{ 'loginForm.password.label' | cxTranslate }}\n      <cx-form-required-asterisks />\n    </span>\n    <input\n      required=\"true\"\n      type=\"password\"\n      class=\"form-control\"\n      placeholder=\"{{ 'loginForm.password.placeholder' | cxTranslate }}\"\n      formControlName=\"password\"\n      [attr.aria-label]=\"'loginForm.password.placeholder' | cxTranslate\"\n      [attr.aria-invalid]=\"\n        form.get('password')?.touched && form.get('password')?.invalid\n      \"\n      [attr.aria-errormessage]=\"'passwordError'\"\n      cxPasswordVisibilitySwitch\n    />\n    <cx-form-errors\n      id=\"passwordError\"\n      [control]=\"form.get('password')\"\n    ></cx-form-errors>\n  </label>\n\n  <a [routerLink]=\"{ cxRoute: 'forgotPassword' } | cxUrl\" class=\"btn-link\">\n    {{ 'loginForm.forgotPassword' | cxTranslate }}\n  </a>\n\n  <button\n    type=\"submit\"\n    class=\"btn btn-block btn-primary\"\n    [disabled]=\"form.disabled\"\n  >\n    {{ 'loginForm.signIn' | cxTranslate }}\n  </button>\n</form>\n"
    }]
  }], () => [], {
    style: [{
      type: HostBinding,
      args: ['class.user-form']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OneTimePasswordLoginFormModeule {
  static {
    this.ɵfac = function OneTimePasswordLoginFormModeule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OneTimePasswordLoginFormModeule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OneTimePasswordLoginFormModeule,
      declarations: [OneTimePasswordLoginFormComponent],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, FormErrorsModule, SpinnerModule, PasswordVisibilityToggleModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ReturningCustomerOTPLoginComponent: {
            component: OneTimePasswordLoginFormComponent,
            guards: [NotAuthGuard]
          }
        }
      })],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, FormErrorsModule, SpinnerModule, PasswordVisibilityToggleModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OneTimePasswordLoginFormModeule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, FormErrorsModule, SpinnerModule, PasswordVisibilityToggleModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ReturningCustomerOTPLoginComponent: {
            component: OneTimePasswordLoginFormComponent,
            guards: [NotAuthGuard]
          }
        }
      })],
      declarations: [OneTimePasswordLoginFormComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class VerificationTokenDialogComponent {
  constructor(launchDialogService) {
    this.launchDialogService = launchDialogService;
    this.VERIFICATION_TOKEN_DIALOG_ACTION = VERIFICATION_TOKEN_DIALOG_ACTION;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: true,
      focusOnEscape: true
    };
  }
  closeModal(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  static {
    this.ɵfac = function VerificationTokenDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VerificationTokenDialogComponent)(i0.ɵɵdirectiveInject(i4.LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: VerificationTokenDialogComponent,
      selectors: [["cx-verification-token-dialog"]],
      standalone: false,
      decls: 28,
      vars: 21,
      consts: [["role", "dialog", "aria-labelledby", "verification-token-dialog-title", 1, "cx-verification-token-dialog", "cx-modal-container", "cx-asm-dialog", 3, "esc", "cxFocus"], [1, "cx-modal-content"], [1, "cx-dialog-header", "modal-header"], [1, "info-icon"], ["type", "INFO"], ["id", "verification-token-dialog-title", "class", "title modal-title", 4, "cxFeature"], [1, "spliter"], [1, "cx-dialog-body", "modal-body"], [1, "cx-dialog-row"], [1, "cx-dialog-item"], [1, "cx-dialog-footer", "modal-footer"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], ["id", "verification-token-dialog-title", 1, "title", "modal-title"]],
      template: function VerificationTokenDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("esc", function VerificationTokenDialogComponent_Template_div_esc_0_listener() {
            return ctx.closeModal(ctx.VERIFICATION_TOKEN_DIALOG_ACTION.OK);
          });
          i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div")(4, "span", 3);
          i0.ɵɵelement(5, "cx-icon", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, VerificationTokenDialogComponent_h3_6_Template, 3, 3, "h3", 5)(7, VerificationTokenDialogComponent_span_7_Template, 3, 3, "span", 5);
          i0.ɵɵelementEnd()();
          i0.ɵɵelement(8, "hr", 6);
          i0.ɵɵelementStart(9, "div", 7)(10, "div", 8)(11, "div", 9);
          i0.ɵɵtext(12);
          i0.ɵɵpipe(13, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(14, "div", 9);
          i0.ɵɵtext(15);
          i0.ɵɵpipe(16, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(17, "div", 9);
          i0.ɵɵtext(18);
          i0.ɵɵpipe(19, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(20, "div", 9);
          i0.ɵɵtext(21);
          i0.ɵɵpipe(22, "cxTranslate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(23, "div", 10)(24, "button", 11);
          i0.ɵɵpipe(25, "cxTranslate");
          i0.ɵɵlistener("click", function VerificationTokenDialogComponent_Template_button_click_24_listener() {
            return ctx.closeModal(ctx.VERIFICATION_TOKEN_DIALOG_ACTION.OK);
          });
          i0.ɵɵtext(26);
          i0.ɵɵpipe(27, "cxTranslate");
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(6);
          i0.ɵɵproperty("cxFeature", "a11yDialogsHeading");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!a11yDialogsHeading");
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 9, "verificationTokenDialog.noReceiveCode"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 11, "verificationTokenDialog.contentLine1"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 13, "verificationTokenDialog.contentLine2"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(22, 15, "verificationTokenDialog.contentLine3"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(25, 17, "verificationTokenDialog.ok"));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(27, 19, "verificationTokenDialog.close"), " ");
        }
      },
      dependencies: [i4.FocusDirective, i4.IconComponent, i1.FeatureDirective, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VerificationTokenDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-verification-token-dialog',
      standalone: false,
      template: "<div\n  class=\"cx-verification-token-dialog cx-modal-container cx-asm-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"closeModal(VERIFICATION_TOKEN_DIALOG_ACTION.OK)\"\n  aria-labelledby=\"verification-token-dialog-title\"\n>\n  <div class=\"cx-modal-content\">\n    <!-- Modal Header -->\n    <div class=\"cx-dialog-header modal-header\">\n      <div>\n        <span class=\"info-icon\">\n          <cx-icon type=\"INFO\"></cx-icon>\n        </span>\n        <h3\n          *cxFeature=\"'a11yDialogsHeading'\"\n          id=\"verification-token-dialog-title\"\n          class=\"title modal-title\"\n        >\n          {{ 'verificationTokenDialog.title' | cxTranslate }}\n        </h3>\n        <span\n          *cxFeature=\"'!a11yDialogsHeading'\"\n          id=\"verification-token-dialog-title\"\n          class=\"title modal-title\"\n        >\n          {{ 'verificationTokenDialog.title' | cxTranslate }}\n        </span>\n      </div>\n    </div>\n    <hr class=\"spliter\" />\n\n    <!-- Modal Body -->\n    <div class=\"cx-dialog-body modal-body\">\n      <div class=\"cx-dialog-row\">\n        <div class=\"cx-dialog-item\">\n          {{ 'verificationTokenDialog.noReceiveCode' | cxTranslate }}\n        </div>\n        <div class=\"cx-dialog-item\">\n          {{ 'verificationTokenDialog.contentLine1' | cxTranslate }}\n        </div>\n        <div class=\"cx-dialog-item\">\n          {{ 'verificationTokenDialog.contentLine2' | cxTranslate }}\n        </div>\n        <div class=\"cx-dialog-item\">\n          {{ 'verificationTokenDialog.contentLine3' | cxTranslate }}\n        </div>\n      </div>\n    </div>\n\n    <!-- Modal Footer -->\n    <div class=\"cx-dialog-footer modal-footer\">\n      <button\n        (click)=\"closeModal(VERIFICATION_TOKEN_DIALOG_ACTION.OK)\"\n        [attr.aria-label]=\"'verificationTokenDialog.ok' | cxTranslate\"\n        class=\"btn btn-primary\"\n        type=\"button\"\n      >\n        {{ 'verificationTokenDialog.close' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i4.LaunchDialogService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultVerificationTokenLayoutConfig = {
  launch: {
    [LAUNCH_CALLER.ACCOUNT_VERIFICATION_TOKEN]: {
      inlineRoot: true,
      component: VerificationTokenDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const globalMsgShowTime = 10000;
class VerificationTokenFormComponentService {
  constructor() {
    this.globalMessage = inject(GlobalMessageService);
    this.verificationTokenFacade = inject(VerificationTokenFacade);
    this.auth = inject(AuthService);
    this.busy$ = new BehaviorSubject(false);
    this.isUpdating$ = this.busy$.pipe(tap(state => {
      state === true ? this.form.disable() : this.form.enable();
    }));
    this.form = new UntypedFormGroup({
      tokenId: new UntypedFormControl('', [Validators.required]),
      tokenCode: new UntypedFormControl('', [Validators.required])
    });
  }
  login() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    this.busy$.next(true);
    from(this.auth.otpLoginWithCredentials(this.form.value.tokenId, this.form.value.tokenCode)).pipe(withLatestFrom(this.auth.isUserLoggedIn()), tap(([_, isLoggedIn]) => this.onSuccess(isLoggedIn))).subscribe();
  }
  displayMessage(key, params) {
    this.globalMessage.add({
      key: key,
      params
    }, GlobalMessageType.MSG_TYPE_CONFIRMATION, globalMsgShowTime);
  }
  createVerificationToken(loginId, password, purpose) {
    return this.verificationTokenFacade.createVerificationToken({
      loginId,
      password,
      purpose
    });
  }
  onSuccess(isLoggedIn) {
    if (isLoggedIn) {
      // We want to remove error messages on successful login (primary the bad
      // username/password combination)
      this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
      this.form.reset();
    }
    this.busy$.next(false);
  }
  static {
    this.ɵfac = function VerificationTokenFormComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VerificationTokenFormComponentService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: VerificationTokenFormComponentService,
      factory: VerificationTokenFormComponentService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VerificationTokenFormComponentService, [{
    type: Injectable
  }], () => [], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class VerificationTokenFormComponent {
  constructor() {
    this.service = inject(VerificationTokenFormComponentService);
    this.launchDialogService = inject(LaunchDialogService);
    this.cdr = inject(ChangeDetectorRef);
    this.routingService = inject(RoutingService);
    this.waitTime = 60;
    this.form = this.service.form;
    this.isUpdating$ = this.service.isUpdating$;
    this.style = true;
    this.isResendDisabled = true;
    this.waitTimeForRateLimit = 300;
  }
  ngOnInit() {
    if (!!history.state) {
      this.tokenId = history.state['tokenId'];
      this.password = history.state['password'];
      this.target = history.state['loginId'];
      this.errorStatus = history.state['errorStatus'];
      history.pushState({
        tokenId: '',
        password: '',
        loginId: '',
        errorStatus: ''
      }, 'verifyToken');
      if (this.errorStatus === 400) {
        this.upToRateLimit = true;
        this.tokenId = 'invalidTokenId';
        this.startRateLimitWaitTimeInterval();
      } else if (!this.target || !this.password || !this.tokenId) {
        this.service.displayMessage('verificationTokenForm.needInputCredentials', {});
        this.routingService.go(['/login']);
      } else {
        this.startWaitTimeInterval();
        this.service.displayMessage('verificationTokenForm.createVerificationToken', {
          target: this.target
        });
      }
    }
  }
  onSubmit() {
    this.service.login();
  }
  resendOTP() {
    this.isResendDisabled = true;
    this.resendLink.nativeElement.tabIndex = -1;
    this.resendLink.nativeElement.blur();
    this.waitTime = 60;
    this.startWaitTimeInterval();
    this.service.createVerificationToken(this.target, this.password, ONE_TIME_PASSWORD_LOGIN_PURPOSE).subscribe({
      next: result => this.tokenId = result.tokenId,
      complete: () => this.service.displayMessage('verificationTokenForm.createVerificationToken', {
        target: this.target
      })
    });
  }
  startWaitTimeInterval() {
    const interval = setInterval(() => {
      this.waitTime--;
      this.cdr.detectChanges();
      if (this.waitTime <= 0) {
        clearInterval(interval);
        this.isResendDisabled = false;
        this.resendLink.nativeElement.tabIndex = 0;
        this.cdr.detectChanges();
      }
    }, 1000);
  }
  openInfoDailog() {
    this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.ACCOUNT_VERIFICATION_TOKEN, this.element);
  }
  onOpenInfoDailogKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.openInfoDailog();
    }
  }
  startRateLimitWaitTimeInterval() {
    const interval = setInterval(() => {
      this.waitTimeForRateLimit--;
      this.cdr.detectChanges();
      if (this.waitTimeForRateLimit <= 0) {
        clearInterval(interval);
        this.upToRateLimit = false;
        this.isResendDisabled = false;
        this.cdr.detectChanges();
      }
    }, 1000);
  }
  static {
    this.ɵfac = function VerificationTokenFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VerificationTokenFormComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: VerificationTokenFormComponent,
      selectors: [["cx-verification-token-form"]],
      viewQuery: function VerificationTokenFormComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c4, 5);
          i0.ɵɵviewQuery(_c5, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resendLink = _t.first);
        }
      },
      hostVars: 2,
      hostBindings: function VerificationTokenFormComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("user-form", ctx.style);
        }
      },
      standalone: false,
      decls: 26,
      vars: 28,
      consts: [["resendLink", ""], ["noReceiveCodeLink", ""], ["class", "overlay", 4, "ngIf"], [3, "ngSubmit", "formGroup"], [1, "label-content"], ["required", "true", "formControlName", "tokenCode", "aria-describedby", "tokenInputHint", 1, "form-control", 3, "placeholder"], [3, "control"], ["class", "rate-limit-error-display", 4, "ngIf"], ["id", "tokenInputHint", 1, "cx-visually-hidden"], ["type", "hidden", "formControlName", "tokenId", 3, "ngModelChange", "ngModel"], ["class", "resend-link-text", 4, "ngIf"], [1, "verify-container"], ["type", "submit", 1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "btn", "btn-block", "btn-secondary", "btn-register", 3, "routerLink"], [1, "overlay"], [1, "rate-limit-error-display"], [1, "resend-link-text"], [1, "left-text"], ["role", "timer", "aria-live", "polite", "aria-atomic", "true"], ["role", "button", "tabindex", "-1", 1, "btn-link", 3, "keydown.enter", "keydown.space", "click", "ngClass"], [4, "ngIf"], [1, "right-text"], ["role", "button", "tabindex", "0", 1, "btn-link", 3, "keydown", "click"]],
      template: function VerificationTokenFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, VerificationTokenFormComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 2);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵelementStart(2, "form", 3);
          i0.ɵɵlistener("ngSubmit", function VerificationTokenFormComponent_Template_form_ngSubmit_2_listener() {
            return ctx.onSubmit();
          });
          i0.ɵɵelement(3, "cx-form-required-legend");
          i0.ɵɵelementStart(4, "label")(5, "span", 4);
          i0.ɵɵtext(6);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵelement(8, "cx-form-required-asterisks");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(9, "input", 5);
          i0.ɵɵpipe(10, "cxTranslate");
          i0.ɵɵelement(11, "cx-form-errors", 6);
          i0.ɵɵtemplate(12, VerificationTokenFormComponent_div_12_Template, 3, 6, "div", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(13, "span", 8);
          i0.ɵɵtext(14);
          i0.ɵɵpipe(15, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(16, "input", 9);
          i0.ɵɵtwoWayListener("ngModelChange", function VerificationTokenFormComponent_Template_input_ngModelChange_16_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.tokenId, $event) || (ctx.tokenId = $event);
            return $event;
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(17, VerificationTokenFormComponent_div_17_Template, 13, 10, "div", 10);
          i0.ɵɵelementStart(18, "div", 11)(19, "button", 12);
          i0.ɵɵtext(20);
          i0.ɵɵpipe(21, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(22, "button", 13);
          i0.ɵɵpipe(23, "cxUrl");
          i0.ɵɵtext(24);
          i0.ɵɵpipe(25, "cxTranslate");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 13, ctx.isUpdating$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 15, "verificationTokenForm.verificationCode.label"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(10, 17, "verificationTokenForm.verificationCode.placeholder"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("control", ctx.form.get("tokenCode"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.upToRateLimit);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 19, "verificationTokenForm.tokenInputHint"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵtwoWayProperty("ngModel", ctx.tokenId);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.upToRateLimit);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("disabled", ctx.form.disabled);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 21, "verificationTokenForm.verify"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(23, 23, i0.ɵɵpureFunction0(27, _c2)));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(25, 25, "verificationTokenForm.back"), " ");
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgIf, i2.ɵNgNoValidate, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.RequiredValidator, i2.FormGroupDirective, i2.FormControlName, i1$2.RouterLink, i4.FormErrorsComponent, i4.SpinnerComponent, i4.FormRequiredAsterisksComponent, i4.FormRequiredLegendComponent, i1$1.AsyncPipe, i1.UrlPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VerificationTokenFormComponent, [{
    type: Component,
    args: [{
      selector: 'cx-verification-token-form',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-spinner class=\"overlay\" *ngIf=\"isUpdating$ | async\"></cx-spinner>\n\n<form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\">\n  <cx-form-required-legend />\n  <label>\n    <span class=\"label-content\">\n      {{ 'verificationTokenForm.verificationCode.label' | cxTranslate }}\n      <cx-form-required-asterisks />\n    </span>\n    <input\n      required=\"true\"\n      class=\"form-control\"\n      formControlName=\"tokenCode\"\n      [placeholder]=\"\n        'verificationTokenForm.verificationCode.placeholder' | cxTranslate\n      \"\n      aria-describedby=\"tokenInputHint\"\n    />\n    <cx-form-errors [control]=\"form.get('tokenCode')\"></cx-form-errors>\n    <div class=\"rate-limit-error-display\" *ngIf=\"upToRateLimit\">\n      {{\n        'register.rateLimitForRegistrationMessage'\n          | cxTranslate: { seconds: waitTimeForRateLimit }\n      }}\n    </div>\n  </label>\n  <span id=\"tokenInputHint\" class=\"cx-visually-hidden\">\n    {{ 'verificationTokenForm.tokenInputHint' | cxTranslate }}\n  </span>\n\n  <input type=\"hidden\" formControlName=\"tokenId\" [(ngModel)]=\"tokenId\" />\n\n  <div *ngIf=\"!upToRateLimit\" class=\"resend-link-text\">\n    <div class=\"left-text\">\n      <span role=\"timer\" aria-live=\"polite\" aria-atomic=\"true\">\n        <a\n          role=\"button\"\n          tabindex=\"-1\"\n          #resendLink\n          (keydown.enter)=\"resendOTP()\"\n          (keydown.space)=\"resendOTP()\"\n          (click)=\"resendOTP()\"\n          class=\"btn-link\"\n          [ngClass]=\"{ 'disabled-link': isResendDisabled }\"\n        >\n          {{ 'verificationTokenForm.resend' | cxTranslate }}\n        </a>\n        <ng-container *ngIf=\"isResendDisabled\">\n          {{\n            'verificationTokenForm.sendRateLime'\n              | cxTranslate: { waitTime: waitTime }\n          }}\n        </ng-container>\n      </span>\n    </div>\n    <div class=\"right-text\">\n      <a\n        role=\"button\"\n        tabindex=\"0\"\n        #noReceiveCodeLink\n        (keydown)=\"onOpenInfoDailogKeyDown($event)\"\n        (click)=\"openInfoDailog()\"\n        class=\"btn-link\"\n      >\n        {{ 'verificationTokenForm.noReceiveCode' | cxTranslate }}\n      </a>\n    </div>\n  </div>\n\n  <div class=\"verify-container\">\n    <button\n      type=\"submit\"\n      class=\"btn btn-block btn-primary\"\n      [disabled]=\"form.disabled\"\n    >\n      {{ 'verificationTokenForm.verify' | cxTranslate }}\n    </button>\n    <button\n      [routerLink]=\"{ cxRoute: 'login' } | cxUrl\"\n      class=\"btn btn-block btn-secondary btn-register\"\n    >\n      {{ 'verificationTokenForm.back' | cxTranslate }}\n    </button>\n  </div>\n</form>\n"
    }]
  }], () => [], {
    style: [{
      type: HostBinding,
      args: ['class.user-form']
    }],
    element: [{
      type: ViewChild,
      args: ['noReceiveCodeLink']
    }],
    resendLink: [{
      type: ViewChild,
      args: ['resendLink']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class VerificationTokenFormModule {
  static {
    this.ɵfac = function VerificationTokenFormModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VerificationTokenFormModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: VerificationTokenFormModule,
      declarations: [VerificationTokenFormComponent, VerificationTokenDialogComponent],
      imports: [CommonModule, FormsModule, KeyboardFocusModule, ReactiveFormsModule, RouterModule, UrlModule, IconModule, I18nModule, FormErrorsModule, SpinnerModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          VerifyOTPTokenComponent: {
            component: VerificationTokenFormComponent,
            guards: [NotAuthGuard],
            providers: [{
              provide: VerificationTokenFormComponentService,
              useClass: VerificationTokenFormComponentService,
              deps: [AuthService, GlobalMessageService, VerificationTokenFacade, WindowRef]
            }]
          }
        }
      }), provideDefaultConfig(defaultVerificationTokenLayoutConfig)],
      imports: [CommonModule, FormsModule, KeyboardFocusModule, ReactiveFormsModule, RouterModule, UrlModule, IconModule, I18nModule, FormErrorsModule, SpinnerModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VerificationTokenFormModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, KeyboardFocusModule, ReactiveFormsModule, RouterModule, UrlModule, IconModule, I18nModule, FormErrorsModule, SpinnerModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent],
      providers: [provideDefaultConfig({
        cmsComponents: {
          VerifyOTPTokenComponent: {
            component: VerificationTokenFormComponent,
            guards: [NotAuthGuard],
            providers: [{
              provide: VerificationTokenFormComponentService,
              useClass: VerificationTokenFormComponentService,
              deps: [AuthService, GlobalMessageService, VerificationTokenFacade, WindowRef]
            }]
          }
        }
      }), provideDefaultConfig(defaultVerificationTokenLayoutConfig)],
      declarations: [VerificationTokenFormComponent, VerificationTokenDialogComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UserAccountComponentsModule {
  static {
    this.ɵfac = function UserAccountComponentsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UserAccountComponentsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: UserAccountComponentsModule,
      imports: [LoginModule, LoginFormModule, VerificationTokenFormModule, LoginRegisterModule, MyAccountV2UserModule, OneTimePasswordLoginFormModeule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [LoginModule, LoginFormModule, VerificationTokenFormModule, LoginRegisterModule, MyAccountV2UserModule, OneTimePasswordLoginFormModeule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserAccountComponentsModule, [{
    type: NgModule,
    args: [{
      imports: [LoginModule, LoginFormModule, VerificationTokenFormModule, LoginRegisterModule, MyAccountV2UserModule, OneTimePasswordLoginFormModeule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LoginComponent, LoginFormComponent, LoginFormComponentService, LoginFormModule, LoginModule, LoginRegisterComponent, LoginRegisterModule, MyAccountV2UserComponent, MyAccountV2UserModule, OneTimePasswordLoginFormComponent, OneTimePasswordLoginFormModeule, UserAccountComponentsModule, VerificationTokenFormComponent, VerificationTokenFormComponentService, VerificationTokenFormModule };
